(function ($) {
    $.validator.setDefaults({
        highlight: function (element, errorClass) {
            $(element).addClass(errorClass);
        },
        unhighlight: function (element, errorClass) {
            $(element).removeClass(errorClass);
        },
        onkeyup: function (element, event) {
            var t = this;
            var excludedKeys = [
                16, 17, 18, 20, 35, 36, 37,
                38, 39, 40, 45, 144, 225,
                91, 93, 224
            ];
            if (event.which === 9 && t.elementValue(element) === "" || $.inArray(event.keyCode, excludedKeys) !== -1) {
                return;
            } else if (element.name in t.submitted || element.name in t.invalid) {
                t.successList.push(element);
                t.showErrors();
                $(element).removeClass(t.settings.errorClass);
            }
        }
    });

    $.validator.unobtrusive.adapters.addBool('booleanrequired', 'required');

    $.validator.addMethod('conditionalrequired', function (value, element, params) {
        var fieldNamePrefix = $(element).attr('name').substring(0, $(element).attr('name').lastIndexOf('.') + 1);
        var propertyValue = $(element).parents('form').find('[name="' + fieldNamePrefix + params[0] + '"]').val();

        if (propertyValue && propertyValue.toLowerCase() === params[1].toLowerCase()) {
            return $.trim(value).length > 0;
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add('conditionalrequired', ['propertyname', 'propertyvalue'], function (options) {
        options.rules['conditionalrequired'] = [options.params['propertyname'], options.params['propertyvalue']];
        options.messages['conditionalrequired'] = options.message;
    });

    $.validator.addMethod('conditionalregex', function (value, element, params) {
        var fieldNamePrefix = $(element).attr('name').substring(0, $(element).attr('name').lastIndexOf('.') + 1);
        var propertyValue = $(element).parents('form').find('[name="' + fieldNamePrefix + params[1] + '"]').val();

        if (propertyValue && propertyValue.toLowerCase() === params[2].toLowerCase()) {
            var r = new RegExp(params[0]);
            return r.test(value);
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add('conditionalregex', ['pattern', 'propertyname', 'propertyvalue'], function (options) {
        options.rules['conditionalregex'] = [options.params['pattern'], options.params['propertyname'], options.params['propertyvalue']];
        options.messages['conditionalregex'] = options.message;
    });

    $.validator.addMethod('messagelength', function (value, element, param) {
        return messageLengthValid;
    });

    $.validator.unobtrusive.adapters.addBool('messagelength');
}(jQuery));

$(document).ready(function () {
    //$('[type!="checkbox"][data-val-required], [type!="checkbox"][data-val-conditionalrequired], [data-val-booleanrequired]').each(function () {
    //    $('label[for="' + $(this).attr('id') + '"]').addClass('required');
    //});

    $('textarea[name$="PersonalMessageText"]').on('keyup paste blur', function () {
        var textarea = $(this);
        var messageCounter = textarea.siblings('.message-counter');

        var maxChars = textarea.data('maxchars');
        var maxLines = textarea.data('maxlines');
        var charsPerLine = textarea.data('charsperline');

        setTimeout(function () {
            messageLengthValid = true;

            var usedChars = textarea.val().length;
            var remainingChars = maxChars - usedChars;

            var linesArray = textarea.val().split("\n");
            var usedLines = linesArray.length;
            for (i = 0; i < linesArray.length; i++) {
                if (linesArray[i].length > charsPerLine) {
                    usedLines += Math.floor(linesArray[i].length / charsPerLine);
                    if (0 === linesArray[i].length % charsPerLine) {
                        usedLines--;
                    }
                }
            }
            var remainingLines = maxLines - usedLines;

            messageCounter.find('.remaining-count').addClass('d-none');
            if (remainingChars < 0) {
                messageLengthValid = false;
                if (remainingChars == -1) {
                    messageCounter.find('.remaining-char-over-single').removeClass('d-none');
                } else {
                    messageCounter.find('.remaining-char-over-multiple').removeClass('d-none').find('.chars-remaining').text(-remainingChars);
                }
            } else {
                if (remainingChars == 1) {
                    messageCounter.find('.remaining-char-single').removeClass('d-none');
                } else {
                    messageCounter.find('.remaining-char-multiple').removeClass('d-none').find('.chars-remaining').text(remainingChars);
                }
            }
            if (remainingLines < 0) {
                messageLengthValid = false;
                if (remainingLines == -1) {
                    messageCounter.find('.remaining-line-over-single').removeClass('d-none');
                } else {
                    messageCounter.find('.remaining-line-over-multiple').removeClass('d-none').find('.lines-remaining').text(-remainingLines);
                }
            } else {
                if (remainingLines == 1) {
                    messageCounter.find('.remaining-line-single').removeClass('d-none');
                } else {
                    messageCounter.find('.remaining-line-multiple').removeClass('d-none').find('.lines-remaining').text(remainingLines);
                }
            }

            if (textarea.hasClass('input-validation-error') || textarea.hasClass('valid')) {
                textarea.valid();
            }
        }, 0);
    }).trigger('keyup');
});